module.exports = __webpack_public_path__ + "static/logo-afd7d1cf0c199c91bbcfb5705dd1ba24.png";